import {TaxInvoiceListElementType, TaxInvoiceSearchParamType} from "../../pages/order/taxInvoice/interface";
import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";

const url = "api/order/tax/";

export async function readTaxList(data: TaxInvoiceSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_tax_list", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function deleteTaxIssue(data: { id: number }[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "delete_tax_issue", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateTaxProgress(data: TaxInvoiceListElementType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_tax_progress", data);
    } catch (err: any) {
        return err?.response;
    }
}

// 내부수정: 날짜 일괄 수정
export async function updateIssueDateBulk(data: { taxIds: number[], issueDate: string }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_tax_issue_date_bulk", data);
    } catch (err: any) {
        return err?.response;
    }
}